export enum ChatFormFieldType {
  Text = 'text',
  Reference = 'entityRef',
  DateTime = 'dateTime',
}

export enum ChatFormOperation {
  Create = 'create',
  Update = 'update',
  Read = 'read',
  Confirm = 'confirm',
}

export interface IChatFormField {
  name: string;
  description?: string;
  type: ChatFormFieldType;
  required: boolean;
  secret: boolean;
  referenceType?: string;
  isCascade?: boolean;
}

export interface IChatForm {
  entity: string;
  operation: ChatFormOperation;
  fields: IChatFormField[];
  values?: Record<string, unknown>;
  isSubmitting?: boolean;
}

export interface IChatFormResolvedEvent {
  values?: Record<string, unknown>;
  declineReason?: string;
}
